import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NbAuthService, NbAuthOAuth2Token } from '@nebular/auth';
import { NbRoleProvider } from '@nebular/security';

@Injectable()
export class HmRoleProvider implements NbRoleProvider {

    constructor(private authService: NbAuthService) {
    }

    getRole(): Observable<string> {
        return this.authService.getToken()
            .pipe(
                map((token: NbAuthOAuth2Token) => {
                    return token.isValid() ? token.getPayload()['scope'][0] : 'guest';
                }),
            );
    }
}
